<template>
  <div>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <v-row dense>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field v-model="group_name" label="発行単位" disabled>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="10">
            <v-file-input
              v-model="input_file"
              accept=".csv"
              :placeholder="config.PLACEHOLDER_FILE"
              prepend-icon="mdi-paperclip"
              outlined
              @change="fileUpload"
            >
              <template v-slot:selection="{ text }">
                <v-chip small label color="primary">{{ text }}</v-chip>
              </template>
            </v-file-input>
          </v-col>
        </v-row>
        <v-divider class="mb-1"></v-divider>
        <template>
          <v-toolbar flat>
            <v-toolbar-title>{{ list_name }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <top-operation-data-table
          :headers="headers"
          :items="items"
          :sort-by="sortBy"
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          must-sort
          class="fixedWidth"
          disp-mode="nowrap"
          ref="temporaryQrCodeRegisterTable"
        >
          <template v-slot:[`item.birthday`]="{ item }">
            {{ formatBirthDay(item.birthday) }}
          </template>
          <template v-slot:[`item.sex`]="{ item }">
            {{ changeFormat("sex", item.sex) }}
          </template>
          <template v-slot:[`item.pregnancy_flg`]="{ item }">
            {{ changeFormat("pregnancy_flg", item.pregnancy_flg) }}
          </template>
          <template v-slot:[`item.lodine_tablets_take_status`]="{ item }">
            {{
              changeFormat(
                "lodine_tablets_take_status",
                item.lodine_tablets_take_status
              )
            }}
          </template>
          <template v-slot:[`item.lodine_tablets_take_flg`]="{ item }">
            {{
              changeFormat(
                "lodine_tablets_take_flg",
                item.lodine_tablets_take_flg
              )
            }}
          </template>
          <template v-slot:[`item.lodine_tablets_status`]="{ item }">
            {{
              changeFormat("lodine_tablets_status", item.lodine_tablets_status)
            }}
          </template>
          <template v-slot:[`item.name_kanji`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="text-truncate d-inline-block"
                  style="max-width: 720px"
                >
                  {{ item.name_kanji }}
                </span>
              </template>
              <span> {{ item.name_kanji }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.name_kana`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="text-truncate d-inline-block"
                  style="max-width: 720px"
                >
                  {{ item.name_kana }}
                </span>
              </template>
              <span> {{ item.name_kana }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.address`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="text-truncate d-inline-block"
                  style="max-width: 720px"
                >
                  {{ item.address }}
                </span>
              </template>
              <span> {{ item.address }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.remarks`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="d-inline-block text-truncate"
                  style="max-width: 720px"
                >
                  {{ item.remarks }}
                </span>
              </template>
              <span> {{ item.remarks }}</span>
            </v-tooltip>
          </template>
        </top-operation-data-table>
        <template v-if="upload_flag">
          <v-row>
            <v-col>
              <v-btn class="mx-2" color="primary" @click="register">
                QRコード登録
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <v-row>
          <v-col>
            <v-btn class="mx-2" color="primary" @click="close">戻る</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <error-dialog ref="errorDialog" />
    <confirm-dialog ref="confirm"></confirm-dialog>
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import ConfirmDialog from "@/components/ConfirmDialog";
import ErrorDialog from "@/components/ErrorDialog";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { ScreenId } from "@/js/value-objects/screen-id";
import messageUtils from "@/mixins/message-utils";
import { ErrorTodoMessages } from "@/js/constants/error-messages";
import config from "@/js/const";

const tmpQrresidentsRepository = RepositoryFactory.get("tmpQrresidents");
const tmpQrcodeUploadRepository = RepositoryFactory.get("tmpQrcodeUpload");

export default {
  mixins: [messageUtils],
  components: {
    ConfirmDialog,
    ErrorDialog,
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },
  data: () => ({
    loading: false, // データテーブルのローディング表示用
    overlay: false, // オーバーレイ表示用
    screenTitle: "", // 画面名
    upload_flag: false, // true：CSV情報取り込み後
    list_name: "登録済みデータ",
    group_id: "", // 発行単位ID
    group_name: "", // 発行単位テキストボックスのv-model
    group_hash: "",
    input_file: null, // ファイルインプットフォームのv-model
    items: [], // データテーブル表示用
    sortBy: ["no"], // ソート対象
    file_group_name: "", // CSVファイルから読み込んだ発行単位名
    file_group_id: "", // CSVファイルから読み込んだ発行単位ID
    tmpQrresidents: [], // 仮QRコードの住民情報
    config: config // 共通プレースホルダ
  }),

  created() {
    this.initialize();
  },

  computed: {
    /**
     * テーブルヘッダー定義
     */
    headers() {
      const headers = [
        {
          text: "状態",
          value: "status",
          sortable: false
        },
        {
          text: "No",
          value: "qrdisp_id"
        },
        {
          text: "氏名",
          value: "name_kanji"
        },
        {
          text: "氏名カナ",
          value: "name_kana"
        },
        {
          text: "生年月日",
          value: "birthday",
          align: "center"
        },
        {
          text: "郵便番号",
          value: "postal_code",
          align: "center"
        },
        {
          text: "現住所",
          value: "address"
        },
        {
          text: "避難元地区",
          value: "eva_area_name",
          align: "center"
        },
        {
          text: "性別",
          value: "sex",
          align: "center"
        },
        {
          text: "要配慮の理由",
          value: "vul_reason",
          align: "center"
        },
        {
          text: "妊娠有無",
          value: "pregnancy_flg",
          align: "center",
          sort: this.emptyStringSorter
        },
        {
          text: "安定ヨウ素剤服用有無",
          value: "lodine_tablets_take_status",
          align: "center",
          sort: this.emptyStringSorter
        },
        {
          text: "安定ヨウ素剤服用可否",
          value: "lodine_tablets_take_flg",
          align: "center",
          sort: this.emptyStringSorter
        },
        {
          text: "安定ヨウ素剤所持状況",
          value: "lodine_tablets_status",
          align: "center",
          sort: this.emptyStringSorter
        },
        {
          text: "安定ヨウ素剤配布番号",
          value: "lodine_tablets_distribution",
          align: "center"
        },
        {
          text: "備考",
          value: "remarks"
        }
      ];
      if (!this.upload_flag) {
        return headers.filter(item => item.value !== "status");
      }
      return headers;
    }
  },
  methods: {
    /**
     * 初期化処理
     */
    async initialize() {
      this.overlay = true;
      this.loading = true;

      // タイトルとブラウザタブー画面名設定
      this.screenTitle = ScreenId.getScreenTitle(ScreenId.SF0608);
      this.pageTitle(this.screenTitle);

      // 発行単位IDの設定
      this.group_id = this.$route.query.group_id;
      // 発行単位の設定
      this.group_name = this.$route.query.group_name;
      // グループHashの設定
      this.group_hash = this.$route.query.hash;

      // 仮QRコード住民情報の取得
      const payload = {
        manage_grp_id: this.group_id
      };
      await tmpQrresidentsRepository
        .list(ScreenId.SF0608, payload)
        .then(response => {
          this.tmpQrresidents = response.data.results;
          this.items = this.tmpQrresidents;
        })
        .catch(e => {
          this.handleError(e, ScreenId.SF0608, "temporary-qr-code-group");
        });

      // ソート設定
      this.sortBy = ["qrdisp_id"];

      // 初期化
      this.list_name = "登録済みデータ";
      this.upload_flag = false;
      this.input_file = null;

      this.loading = false;
      this.overlay = false;

      // ページを1ページに移動する
      // initializeのresetPageはアップファイル削除時に必要なので追加
      this.$refs.temporaryQrCodeRegisterTable.resetPage();
    },

    /**
     * ファイルアップロード時処理
     * @param {*} file ファイル情報
     */
    async fileUpload(file) {
      /* ファイルが選択されていない場合 */
      if (!file) {
        this.initialize();
        return;
      }
      /* ファイルが選択されている場合 */
      if (!file.name.toUpperCase().match(/\.(CSV)$/i)) {
        // csvファイル以外を選択した場合はエラーダイアログを表示
        await this.$refs.errorDialog.open(ErrorTodoMessages.ERWE40010);
        this.initialize();
        return;
      }
      // ファイル読み込み～テーブルへの変換処理
      const fr = new FileReader();
      fr.readAsText(file);
      fr.addEventListener("load", () => {
        this.convertCSVtoItem(fr.result);
      });
    },

    /**
     * ファイル読み込み～テーブルへの変換処理
     */
    async convertCSVtoItem(str) {
      // 配列に変換
      const csvArray = this.convertCSVtoArray(str);
      /* エラーチェック */
      // 配列の数確認（ExcelでCSVファイルを開いて保存すると最終行に改行が入る為、念のため「!(e.length === 1 && !e[0])」を見ている）
      // i：rowNum, ele:RowData
      for (let [i, ele] of csvArray.entries()) {
        // 仮QRコードグループ値チェック || 行のデータの有無チェック
        if (
          (i === 0 && ele.length !== 3) ||
          (i !== 0 && ele.length !== 16 && !(ele.length === 1 && !ele[0]))
        ) {
          // エラーダイアログの表示
          await this.$refs.errorDialog.open(ErrorTodoMessages.ERWE40007);
          this.initialize();
          return;
        }
      }

      // 発行単位エラー
      if (!(csvArray[0][2] === this.group_id)) {
        // エラーダイアログの表示
        await this.$refs.errorDialog.open(
          ErrorTodoMessages.ERWE40011(this.group_id, csvArray[0][2])
        );
        this.initialize();
        return;
      }

      /* CSV情報取得 */
      const csvItems = [];
      csvArray.forEach((ele, i) => {
        // タイトル行の情報取得
        if (i === 0) {
          this.file_group_name = ele[1];
          this.file_group_id = ele[2];
        }
        // ヘッダー行の場合は、早期return
        if (i < 2) {
          return;
        }
        // コード名をコードに変える
        csvItems.push({
          // No
          qrdisp_id: ele[0],
          // 氏名
          name_kanji: ele[1],
          // 氏名カナ
          name_kana: ele[2],
          // 生年月日(形式：YYYYMMDD)
          birthday:
            ele[3] == ""
              ? ""
              : this.$moment(ele[3], "YYYY/MM/DD").format("YYYYMMDD"),
          // 郵便番号
          postal_code: ele[4],
          // 現住所
          address: ele[5],
          // 避難元地区
          eva_area_name: ele[6],
          // 性別
          sex: (() => {
            if (ele[7] == "男") {
              return "1";
            } else if (ele[7] == "女") {
              return "2";
            } else if (ele[7] == "どちらでもない") {
              return "3";
            } else {
              return "";
            }
          })(),
          // 妊娠有無
          pregnancy_flg: ele[8] == "" ? "" : ele[8] == "無" ? "0" : "1",
          // 要配慮の理由
          vul_reason: ele[9],
          // 安定ヨウ素剤服用状況
          lodine_tablets_take_status:
            ele[10] == "" ? "" : ele[10] == "無" ? "0" : "1",
          // 安定ヨウ素剤服用可否
          lodine_tablets_take_flg:
            ele[11] == "" ? "" : ele[11] == "否" ? "0" : "1",
          // 安定ヨウ素剤所持状況
          lodine_tablets_status:
            ele[12] == "" ? "" : ele[12] == "無" ? "0" : "1",
          // 安定ヨウ素剤配布番号
          lodine_tablets_distribution:
            ele[13] == "" ? "" : String(ele[13]).padStart(12, "0"),
          // 備考
          remarks: ele[14],
          // 発行日(形式：YYYYMMDD)
          issue_date: this.$moment(ele[15], "YYYY/MM/DD").format("YYYYMMDD")
        });
      });

      /* テーブルデータ作成 */
      // initialize時に取得した情報をベースとして、CSV取り込み情報との差分を求める（登録以外）
      this.loading = true;
      const pushItems = [];
      this.tmpQrresidents.forEach(item => {
        let targetItem = csvItems.find(csvItem => {
          // CSV空の取り込み情報は文字列型、APIからの取得情報は数値型の為、「==」で比較している
          return csvItem.qrdisp_id == item.qrdisp_id;
        });
        let pushItem = cloneDeep(item);

        if (!targetItem) {
          // Noが一致するアイテムが存在しない場合（削除）（サーバーのデータが存在しない場合）
          pushItem.status = "削除";
        } else {
          // Noが一致するアイテムが存在する場合（更新or変更なし）
          const updateFlag = Object.keys(targetItem).some(key => {
            // 発行日の場合、値が変わらないためPASSする
            if (key === "issue_date") {
              return false;
            }
            // アイテムが一つでも一致しなければ新規or更新（型の不一致による誤差を防ぐため、「!=」で比較している）
            return targetItem[key] != item[key];
          });
          if (updateFlag) {
            // アイテムに変更がある場合（新規or更新）
            // CSV取り込み情報で値を上書き
            pushItem.name_kanji = targetItem.name_kanji;
            pushItem.name_kana = targetItem.name_kana;
            pushItem.birthday = targetItem.birthday;
            pushItem.postal_code = targetItem.postal_code;
            pushItem.address = targetItem.address;
            pushItem.eva_area_name = targetItem.eva_area_name;
            pushItem.sex = targetItem.sex;
            pushItem.pregnancy_flg = targetItem.pregnancy_flg;
            pushItem.vul_reason = targetItem.vul_reason;
            pushItem.lodine_tablets_take_status =
              targetItem.lodine_tablets_take_status;
            pushItem.lodine_tablets_take_flg =
              targetItem.lodine_tablets_take_flg;
            pushItem.lodine_tablets_status = targetItem.lodine_tablets_status;
            pushItem.lodine_tablets_distribution =
              targetItem.lodine_tablets_distribution;
            pushItem.remarks = targetItem.remarks;
            pushItem.issue_date = targetItem.issue_date;

            // 行の修正有無チェック（元のデータの情報を調べる）
            // true: 変更あり,false:変更なし
            const ROW_STATE_FLG = Object.keys(item).every(key => {
              // 発行日の場合、値が変わらないためPASSする
              if (key == "qrdisp_id" || key == "issue_date") {
                return true;
              }
              return item[key] != "";
            });

            // 行の状態区分
            if (ROW_STATE_FLG) {
              //サーバーにデータは存在するけど、マクロで行の情報を全部消した場合「削除」にする（論理的に削除）
              const deleteFlg = Object.keys(targetItem).every(key => {
                // 発行日の場合、値が変わらないためPASSする
                if (key == "qrdisp_id" || key == "issue_date") {
                  return true;
                }
                return targetItem[key] == "";
              });

              pushItem.status = deleteFlg ? "削除" : "更新";
            } else {
              // 元データが空の場合（新規）
              pushItem.status = "新規";
            }
          } else {
            // アイテムに変更がない場合（-）
            pushItem.status = "－";
          }
        }
        pushItems.push(pushItem);
      });
      // テーブルデータ設定
      this.items = pushItems;
      this.loading = false;

      // タイトル設定
      this.list_name = "登録データ(確認)";
      // 更新フラグ設定（QRコード登録ボタンを有効化）
      this.upload_flag = true;
      // ソート設定
      this.sortBy = ["qrdisp_id"];
      // ページを1ページに移動する
      this.$refs.temporaryQrCodeRegisterTable.resetPage();
    },

    /**
     * 読み込んだCSVデータを二次元配列に変換する
     */
    convertCSVtoArray(str) {
      let result = [];
      let tmp = str.split("\n");

      // 各行ごとにカンマで区切った文字列を要素とした二次元配列を生成
      for (let i = 0; i < tmp.length; ++i) {
        result[i] = tmp[i].split(",");
        // \rの削除
        result[i][result[i].length - 1] = result[i][
          result[i].length - 1
        ].replace(/\r?\n?/g, "");
      }
      return result;
    },

    /**
     * QRコード登録ボタン押下時処理
     */
    async register() {
      /* 登録確認ダイアログ表示 */
      // 登録済の場合、全件入れ替えとして、すでに登録があればメッセージを表示して注意を促す。
      const message = "一覧表示の状態で更新されますがよろしいでしょうか？";
      const result = await this.$refs.confirm.open(message, "登録");
      if (!result) {
        return;
      }
      const list = [];
      this.items.forEach(item => {
        list.push({
          tmpqr_id: item.tmpqr_id,
          name_kanji: item.name_kanji,
          name_kana: item.name_kana,
          birthday: item.birthday,
          postal_code: item.postal_code,
          disp_address: item.address,
          eva_area_name: item.eva_area_name,
          sex: item.sex,
          vul_reason: item.vul_reason,
          pregnancy_flg: item.pregnancy_flg,
          lodine_tablets_take_status: item.lodine_tablets_take_status,
          lodine_tablets_take_flg: item.lodine_tablets_take_flg,
          lodine_tablets_status: item.lodine_tablets_status,
          lodine_tablets_distribution: item.lodine_tablets_distribution,
          remarks: item.remarks
        });
      });
      let payload = {
        grp_hash: this.group_hash,
        tmpqr_grp_id: this.group_id,
        manage_grp_name: this.group_name,
        list: list
      };

      this.overlay = true;
      await tmpQrcodeUploadRepository
        .registerTmpQrcode(ScreenId.SF0608, payload)
        .then(response => {
          this.handleSuccess(response, "temporary-qr-code-group");
          // this.$router.push({
          //   path: `/temporary-qr-code`
          // });
        })
        .catch(e => {
          this.handleError(e, "SF0605", "temporary-qr-code-group");
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    /**
     * 戻るボタン押下時処理
     */
    close() {
      this.$router.push({
        path: `/temporary-qr-code`
      });
    },

    /**
     * データテーブル表示用（生年月日）
     */
    formatBirthDay(date) {
      const formattedDate = this.$moment(date);
      if (formattedDate.isValid()) {
        return formattedDate.format("YYYY年MM月DD日");
      }
      return "";
    },

    /**
     * テーブルのカラムのフォーマット変更
     */
    changeFormat(columnName, value) {
      switch (columnName) {
        // 妊娠有無
        case "pregnancy_flg":
          return value == "" ? "" : value == 0 ? "無" : "有";
        // 安定ヨウ素剤服用有無
        case "lodine_tablets_take_status":
          return value == "" ? "" : value == 0 ? "無" : "有";
        // 安定ヨウ素剤服用可否
        case "lodine_tablets_take_flg":
          return value == "" ? "" : value == 0 ? "否" : "可";
        // 安定ヨウ素剤所持状況
        case "lodine_tablets_status":
          return value == "" ? "" : value == 0 ? "無" : "有";
        // 性別
        case "sex":
          if (value == 1) {
            return "男";
          } else if (value == 2) {
            return "女";
          } else if (value == 3) {
            return "どちらでもない";
          } else {
            return "";
          }
      }
      return value;
    },

    /**
     * カスタムソーター
     * 空白を含むセルが存在する時、セルのソーター結果に異常があるため作成
     * ヘッダーの昇順降順選択によってa,bの値が変わる
     */
    emptyStringSorter(a, b) {
      if (a !== b) {
        const sortList = ["", "1", "0"];
        const indexA = sortList.indexOf(a);
        const indexB = sortList.indexOf(b);
        // sortListによる昇順・降順切り分け
        if (indexA > indexB) {
          return 1;
        } else {
          return -1;
        }
      }
      return 0;
    }
  }
};
</script>
